import fileUploadViewer from './FileUploadViewer';

export default angular.module('edge.platform.widgets.fileupload', []).directive('gwFileUploadViewer', fileUploadViewer);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/fileupload/module.js
// module id = 356
// module chunks = 0